import { render } from "./ParticipatingProducts.vue?vue&type=template&id=74bc9a36"
import script from "./ParticipatingProducts.vue?vue&type=script&lang=js"
export * from "./ParticipatingProducts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__